import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type { NewsCategory } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategory";
import type {
    MatchingFunction,
    TranslatableNameWithType,
} from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import type { FilterNameResolver } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import filterNamingService from "app/pages/sales-intelligence/sub-modules/signals/services/filters/filterNamingService";
import { matchNewsCategoryToName } from "app/pages/sales-intelligence/sub-modules/signals/utils/news/filters";

function createNewsCategoriesNameFactory(): FilterNameResolver {
    const matchValueToName: MatchingFunction = (category: NewsCategory) => {
        const { key } = matchNewsCategoryToName(category);

        return key;
    };

    return {
        buildName<F extends SignalFilters & { categories: readonly NewsCategory[] }>(
            filters: F,
            options: readonly NewsCategory[],
            translationOptions = { i18nKeyModifier: "" },
        ): Readonly<TranslatableNameWithType> {
            const numberOfOptions = options.length;

            return filterNamingService.buildNameForSelection({
                values: filters.categories,
                numberOfOptions,
                matchValueToName,
                translationOptions,
            });
        },
    };
}

export default createNewsCategoriesNameFactory;
